// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-monaco-editor',
    editor: null,
    // #endregion
    // #region Events
    emits: ["change", "input"],
    // #endregions
    // #region Properties
    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
        containerAttr: {
            type: Object,
            required: false,
            default: {},
        },
        language: {
            type: String,
            required: false,
            default: 'plaintext',
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        isMinimapEnabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    // #endregion
    // #region Data
    data: () => ({
        _isSettingValue: false,
    }),
    // #endregion
    // #region Watch
    watch: {
        value: {
            handler(newValue, oldValue) {
                this.setValue(newValue);
            },
            deep: true
        }
    },
    // #endregion
    // #region Constructor
    async mounted() {
        //Vars
        var tGlobal = window;
        var tDom = this.$refs['editor'];
        if (!tGlobal.require) {
            tGlobal.require = {};
        }
        if (!tGlobal.require.paths) {
            tGlobal.require.paths = {};
        }
        //Set
        tGlobal.require.paths.vs = '/assets/lib/monaco/min/vs';
        //Scripts
        await appHost.pageMeta.loadScript('/assets/lib/monaco/min/vs/loader.js');
        await appHost.pageMeta.loadScript('/assets/lib/monaco/min/vs/editor/editor.main.nls.js');
        await appHost.pageMeta.loadScript('/assets/lib/monaco/min/vs/editor/editor.main.js');
        //Styles
        await appHost.pageMeta.loadStyle('/assets/lib/monaco/min/vs/editor/editor.main.css');
        //New
        tDom.__editor = tGlobal.monaco.editor.create(tDom, {
            language: this.language,
            automaticLayout: true,
            scrollBeyondLastLine: false,
            readOnly: this.readOnly,
            minimap: {
                enabled: this.isMinimapEnabled
            },
        });
        //Events
        tDom.__editor.onDidChangeModelContent((event) => {
            this.emitChange(tDom.__editor.getValue(), event);
        });
        //Data
        if (this.value) {
            this.setValue(this.value);
        }
        ;
    },
    beforeDestroy() {
        if (this.$refs['editor'].__editor) {
            this.$refs['editor'].__editor.dispose();
        }
    },
    // #endregion
    // #region Methods
    methods: {
        getEditor() {
            if (!this.$refs['editor'].__editor) {
                return null;
            }
            return this.$refs['editor'].__editor;
        },
        setValue(value) {
            let editor = this.getEditor();
            if (editor) {
                this._isSettingValue = true;
                if (utils.isObject(this.value)) {
                    editor.setValue(utils.toJsonString(this.value, true));
                }
                else {
                    editor.setValue(value);
                }
                this._isSettingValue = false;
            }
        },
        getValue() {
            let editor = this.getEditor();
            if (!editor) {
                return '';
            }
            return editor.getValue();
        },
        emitChange(value, event) {
            if (this._isSettingValue) {
                return;
            }
            if (value !== this.value) {
                this.$emit('change', value, event);
                this.$emit('input', value);
            }
        }
    }
    // #endregion
});
// #endregion
